import { Icons, Icon, ListRenderer } from '@feast-it/ui/light';
import React, { ReactElement } from 'react';

import { Area, StyledHeading, PaymentGrid } from '../Footer.styled';
import { useIsDarkTheme } from '../../../context/DarkThemeContext';

interface PaymentsGridProps {
  paymentTypes: (keyof Icons)[];
}

export function PaymentsGrid({
  paymentTypes,
}: PaymentsGridProps): ReactElement {
  const isDark = useIsDarkTheme();

  return (
    <Area name="payments">
      <StyledHeading
        as="h2"
        style="headingBoldMobileExtraSmall"
        color={isDark ? 'white' : 'black'}
      >
        Payments
      </StyledHeading>

      <PaymentGrid>
        <ListRenderer
          items={paymentTypes}
          render={({ item }) => (
            <Icon
              aria-label={item}
              size={70}
              name={item}
              fill={isDark ? 'white' : 'black'}
            />
          )}
        />
      </PaymentGrid>
    </Area>
  );
}
